module.exports = __webpack_public_path__ + "static/media/TONGUE.07c7fa83.svg";